import { TAdminConfiguration } from '@answerr/types';
import { ConfigurationsResponse } from '../types/api-response.type';
import http from '../utils/http-common';

const getConfigurations = () => {
  return http.get<ConfigurationsResponse>('/admin/configuration/get');
};

const updateConfigurations = (data: TAdminConfiguration) => {
  return http.post<ConfigurationsResponse>('/admin/configuration/update', data);
};

const ConfigurationsService = {
  getConfigurations,
  updateConfigurations,
};

export default ConfigurationsService;
